import { ModelBase } from "../base"
import { QuestionnaireQuestionModel } from "../questionnaire-question/index"

export class QuestionnaireSectionModel extends ModelBase {
    id = 0;
    title = "";
    rank = 0;
    questionnaireSectionContent = [
        new QuestionnaireSectionContent()
    ]
    questionnaireQuestions = [
        new QuestionnaireQuestionModel()
    ]

    constructor(params) {
        super();
        this.mapModel(params);
    }
}

export class QuestionnaireSectionCreateModel extends ModelBase {
    id = 0;
    title = "";
    rank = 0;

    constructor(params) {
        super();
        this.mapModel(params);
    }
}

export class QuestionnaireSectionContent extends ModelBase {
    id = 0;
    questionnaireSectionId = 0;
    languageId = 0;
    name = "";
    description = "";

    constructor(params) {
        super();
        this.mapModel(params);
    }
}